// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"476":"74e94e8a","5526":"30334cd0","5635":"2434615a"}[chunkId] + ".chunk.css";
};